var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq24(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15352,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3898,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.9773,
    y1: 12.1824,
    x2: 50.2136,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30349,
    y1: 49.8543,
    x2: 12.5398,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.7395,
    y1: 38.6199,
    x2: 49.9758,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.06565,
    y1: 0.944118,
    x2: 12.302,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.714 30.23C20.4313 28.942 21.7567 27.7893 22.69 26.772C23.6327 25.7453 24.104 24.742 24.104 23.762C24.104 23.118 23.9407 22.6047 23.614 22.222C23.2967 21.83 22.774 21.634 22.046 21.634C21.3367 21.634 20.786 21.858 20.394 22.306C20.0113 22.7447 19.7967 23.3327 19.75 24.07H18.798C18.854 23.034 19.1713 22.2313 19.75 21.662C20.338 21.0833 21.1033 20.794 22.046 20.794C22.9513 20.794 23.684 21.0507 24.244 21.564C24.804 22.068 25.084 22.7867 25.084 23.72C25.084 24.8493 24.6127 25.946 23.67 27.01C22.7367 28.0647 21.584 29.096 20.212 30.104H25.392V30.93H18.714V30.23ZM26.4877 28.62V27.878L31.5837 21.018H32.7457V27.766H34.2437V28.62H32.7457V31H31.7797V28.62H26.4877ZM31.8217 22.096L27.6217 27.766H31.8217V22.096Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq24);
export default __webpack_public_path__ + "static/media/fq24.9e257110b9bcde4cefaeaf609b6fabea.svg";
export { ForwardRef as ReactComponent };